/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { debounce } from "@adapptio/lib-editor-ui";
import { isFunction } from "@adapptio/lib-shared";

export function Debounce(timeout = 166): MethodDecorator {
	return function (target, propertyKey, descriptor) {
		const original = descriptor.value;

		if (!isFunction(original)) {
			return original;
		}

		return {
			configurable: true,
			enumerable: false,
			get(this) {
				const debounced = debounce(original.bind(this), timeout);

				Object.defineProperty(this, propertyKey, {
					value: debounced,
					configurable: true,
					writable: true
				});

				return debounced as unknown as typeof original;
			}
		};
	};
}
